/**
 * RENDERING: UIRenderer
 * Rendering dell'interfaccia utente (score, vite, livello)
 */

import { COLORS } from '../types/GameConstants'

export class UIRenderer {
  static render(
    ctx: CanvasRenderingContext2D,
    score: number,
    lives: number,
    level: number,
    width: number
  ) {
    // Score and Level
    ctx.fillStyle = COLORS.TEXT
    ctx.font = '16px monospace'
    ctx.fillText(`Score: ${score}`, 10, 30)
    ctx.fillText(`Level: ${level}`, 150, 30)
    
    // Lives (Pacman icons)
    ctx.fillStyle = COLORS.PACMAN
    for (let i = 0; i < lives; i++) {
      ctx.beginPath()
      ctx.arc(width - 30 - i * 25, 20, 8, 0.2, 2 * Math.PI - 0.2)
      ctx.lineTo(width - 30 - i * 25, 20)
      ctx.fill()
    }
  }
}
